import { NgModule } from '@angular/core'
import { ButtonFlatDirective } from './button-flat.directive'

@NgModule({
    declarations: [ButtonFlatDirective],
    exports: [ButtonFlatDirective]
})
export class ButtonFlatModule {}
